'use client';

import { CSPostHogProvider } from '@/components/posthog/providers';
import { TooltipProvider } from '@/components/shadcn/tooltip';
import { toast } from '@/components/ui/Toasts/use-toast';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import { PostHogIdentify } from '@/components/posthog/indentify';
import { SWRConfig } from 'swr';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SWRConfig
        value={{
          onError: (error) => {
            toast({
              variant: 'destructive',
              title: 'Failed to load data',
              description:
                error?.message === 'Failed to fetch'
                  ? 'Could not connect to the database. Check your connection.'
                  : error?.message || 'An unexpected error occurred.'
            });
          }
        }}
      >
        <TooltipProvider>
          <CSPostHogProvider posthogKey="phc_pgK5bGtThfl8ia42F1rJOjR92WIgvpr7K7LQwRKLzlm">
            <PostHogIdentify>{children}</PostHogIdentify>
          </CSPostHogProvider>
        </TooltipProvider>
      </SWRConfig>
      <ProgressBar options={{ showSpinner: false }} />
    </>
  );
}
